import { computed } from 'vue';
import { GlobalStore } from '@/store/global';
import { ApplicationState } from '@/platform/ApplicationState';

export class AppCB {
	public readonly page: string | undefined;

	public isApplicationReady = computed<boolean>(() => {
		return GlobalStore.getters.getApplicationState() === ApplicationState.READY;
	});

	public isApplicationIdle = computed<boolean>(() => {
		return GlobalStore.getters.getApplicationState() === ApplicationState.IDLE;
	});

	public constructor(page: string | undefined) {
		this.page = page;
	}
}
